/** 香港時區的今日日期 YYYY-MM-DD（與後端一致） */
export function getTodayHK(): string {
  return new Date().toLocaleDateString("en-CA", {
    timeZone: "Asia/Hong_Kong"
  });
}
